
export const Tagline = ({ children }) => {
    return <h1 className="stepper-form-tagline">{children}</h1>;
  };